import { CGCollection, CGProduct } from '../../types/shopify';
import { cgtag } from '../../utilities/gtag';
import { CGCardSize } from '../Product/CardMaster';
import ProductCardSlider from '../Product/ProductCardSlider';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import useTheme from '@mui/material/styles/useTheme';

import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { shopifyExtractId } from 'lib/shopifyHelpers';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Container from 'components/Layout/Container';
import { ReactComponent as ArrowRightIcon } from '../../assets/icons/arrowRightBlack.svg';
import SvgIcon from '@mui/material/SvgIcon';
// import debug from 'debug';
// const d = debug('CollectionListItem');

const CollectionListItem: React.FC<{
  title?: string;
  item: CGCollection;
  background: string;
}> = ({ title = null, item, background = 'transparent' }) => {
  // d(item.handle, item);
  const theme = useTheme();
  const history = useHistory();
  const cardSize: CGCardSize = useMediaQuery(theme.breakpoints.down('md')) ? 'small' : 'medium';
  const tags = item?.pd?.tags?.slice(0, 3) || [];
  const handleView = () => {
    history.push('/landing/' + item.handle);
  };

  const handleProductClick = (product: CGProduct) => {
    cgtag('select_content', {
      content_type: 'product',
      item_id: shopifyExtractId(product.id.toString()),
      item_name: product.title,
    });
    history.push('/product/' + product.handle);
  };

  return (
    <Box
      sx={{
        pb: 1.5,
        backgroundColor: background,
        filter: 'drop-shadow(0px -10px 10px rgba(0, 0, 0, 0.25))',
      }}
    >
      <Container maxWidth="xl">
        <Stack
          sx={{
            pt: 2,
            pb: 1,
            cursor: 'pointer',
            '&:hover .title': {
              fontWeight: 'bold',
            },
            '&:hover .icon': {
              transition: '0.25s',
              marginLeft: 2,
              color: 'rgba(255,255,255,0.5)',
            },
          }}
          justifyContent="space-between"
          direction={{
            xs: 'column',
            md: 'row',
          }}
          spacing={1}
          alignItems={{
            xs: 'flex-start',
            md: 'center',
          }}
          onClick={handleView}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Box className="title" component={RouterLink} to={`/landing/${item.handle}`} sx={{ typography: 'h1', color: 'info.light', textDecoration: 'none' }}>
              {title || item.title}
              <IconButton
                component="span"
                aria-label="go to collection"
                sx={{
                  color: 'rgba(255,255,255,0.2)',
                  // mt: 0.25,
                  ml: 1.5,
                  p: 0,
                  mb: 0.25,
                  fontSize: {
                    xs: 20,
                    md: 28,
                  },
                }}
                className="icon"
                size="small"
              >
                <SvgIcon component={ArrowRightIcon} fontSize="inherit" />
              </IconButton>
            </Box>
          </Box>
          <Box
            sx={{ display: 'inline-flex', flexWrap: 'wrap', gap: 2 }}
            // direction="row"
            // spacing={2}
          >
            {tags.map((tag, index) => (
              <Link
                key={tag}
                onClick={(ev) => {
                  ev.stopPropagation(); // Don't jump to collection landing page.
                  history.push(`/search?query=${tag}`);
                }}
                sx={{
                  typography: 'h6',
                  color: 'info.light',
                  whiteSpace: 'nowrap',
                }}
              >
                {tag}
              </Link>
            ))}
          </Box>
        </Stack>
      </Container>
      <ProductCardSlider title={title || item.title} items={item.products} forceCardSize={cardSize} hasBadge onClick={handleProductClick} hideTitle={true} padFirstAndLast={true} />
    </Box>
  );
};

export default CollectionListItem;
